import { inject, Injectable, NgZone } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SettingsOrderDiscount } from '@core/models';
import { combineLatest, Observable, Subject } from 'rxjs';
import {
  filter,
  skip,
  startWith,
  switchMap,
  take,
  takeUntil
} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DiscountBannerService {
  private router = inject(Router);
  private zone = inject(NgZone);
  private bannerEl!: HTMLElement;
  private alive$ = new Subject<void>();

  init(
    bannerEl: HTMLElement,
    orderDiscount$: Observable<SettingsOrderDiscount>
  ) {
    this.bannerEl = bannerEl;

    combineLatest([
      orderDiscount$.pipe(skip(1)),
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd),
        switchMap(() => this.zone.onStable.pipe(take(1))),
        startWith(false)
      )
    ])
      .pipe(takeUntil(this.alive$))
      .subscribe(([orderDiscount, _]) => {
        if (!orderDiscount) {
          this.removeBanner();
          this.clear();
          return;
        }

        if (orderDiscount.bannerVisible) {
          this.insertBanner();
        } else {
          this.removeBanner();
        }
      });
  }

  clear() {
    this.alive$.next();
    this.alive$.complete();
  }

  private insertBanner() {
    const header = document.querySelector('app-header');

    if (header && header.nextElementSibling !== this.bannerEl) {
      header.insertAdjacentElement('afterend', this.bannerEl);
    }
  }

  private removeBanner() {
    this.bannerEl?.remove();
  }
}
